module.exports = __webpack_public_path__ + "img/img_bg.55f964a6.png";